const forgotPasswordEN = {
	title: "Forgot your password?",
	subtitle: "Enter your email and we’ll send you a reset link.",
	email: "Email address",
	send: "Send reset link",
	sending: "Sending...",
	success: "Check your email for password reset instructions.",
	toast: {
		error: "Could not send password reset email. Please try again.",
	},
};

export default forgotPasswordEN;
